// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Kunde, KundeDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useCreateKunde(): (requestBody: KundeDaten) => Promise<Kunde> {
  const getAPI = useGetApi();
  return useCallback(
    async (requestBody) => (await getAPI()).kunden.createKunde({ requestBody }),
    [getAPI]
  );
}
